import LinkButton from '~/components/button/LinkButton';
import Page from '~/components/layout/page/Page';
import { useLoaderData } from './shippingIssue';

export default function ShippingIssuePage() {
  const { description, headline, to, buttonText } = useLoaderData();

  return (
    <Page.Root title={headline}>
      {description}
      <LinkButton variant="filled" to={to} className="w-full md:w-1/2">
        {buttonText}
      </LinkButton>
    </Page.Root>
  );
}
